// import { useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ProfileContext } from './contexts';

function useCheckout() {
	// const profileContext = useContext(ProfileContext);
	// const navigate = useNavigate();

	/*return (path = '/') => {
		if (profileContext.expert !== undefined) {
			if (!profileContext.fetchingExpert) {
				if (
					!profileContext.expert?.checkoutVerified &&
					path !== '/stripe/checkout'
				) {
					navigate('/stripe/checkout');
				} else {
					return true;
				}
			}

			return false;
		}

		return false;
	};*/

	return () => true;
}

export default useCheckout;
